
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
import List from './List.vue'
import EmptySearch from './EmptySearch.vue'
export default {
  components: { InnerPageTitle, List, EmptySearch },
  data() {
    return {
      search: '',
    }
  },
  props: {
    results: {
      default: () => [],
    },
  },
  methods: {
    SET_SEARCH_FROM_QUERY() {
      const q = this.$route.query.q
      if (q) this.search = q
    },
  },
  created() {
    this.SET_SEARCH_FROM_QUERY()
  },
}
